/* @ngInject */
const myTrainSearchForm = (
  toaster
) => {
  return {
    restrict: 'E',
    scope: {
      myTrain: '=',
      myTrains: '=',
    },
    template: require('./myTrainSearchForm.html'),
    /* @ngInject */
    controller: (
      $scope,
      utils,
      $$train
    ) => {
      $scope.moreOptions = false

      $scope.searchTrain = async (_myTrain) => {
        const myTrain = utils.copy(_myTrain)
        myTrain.dateBegin = utils.date.stringToServer(myTrain.dateBegin)
        myTrain.dateEnd = utils.date.stringToServer(myTrain.dateEnd)

        try {
          const response = await $$train.request.getByQuickSearch(myTrain)
          $scope.myTrains = response.trains
          toaster.message(response.message, response.color)
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.reinitForm = () => {
        $scope.myTrains.splice(0, $scope.myTrains)
        $scope.myTrain = $$train.new.search()
      }
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myTrainSearchForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/directives/forms/myTrainSearchForm.js